class UsersOnline {
    constructor(app, connectionManager) {
        this.connectionManager = connectionManager;
        this.connectionManager.addHandler(this.updateUsersOnline.bind(this), "cego:xmpp:users:online");
        this.onlineStateCheck = null;
        this.reloadPending = false;
    }

    updateUsersOnline(message) {
        const data = app.util.jsonDecode(message.querySelector("body").innerHTML);
        if (typeof data === "object" && data.type === "users_online") {
            this.setTotalUsersOnline(data.data.site);
            this.setUserOnlineInGames(data.data.games);
            if (data.data.version !== app.config.version && this.reloadPending === false) {
                this.reloadPending = true;
                setTimeout(() => {
                    app.notifications.showForceReload(app.config.translate.force_reload_title, app.config.translate.force_reload_message, (app.util.getTime() / 1000) + 3600);
                    this.reloadPending = false;
                }, ((Math.random() * 10800) + 14400) * 1000);
            }
        }
        return true;
    }

    setTotalUsersOnline(totalOnline) {
        const totalUsersOnline = document.getElementById("total-users-online");
        if (totalUsersOnline) {
            app.util.counter(totalUsersOnline, totalOnline, 55000);
        }
    }

    setUserOnlineInGames(games) {
        const inGame = document.getElementById("online-count");
        if (inGame) {
            const gameName = inGame.getAttribute("data-game");
            if (typeof games[gameName] === "number") {
                app.util.counter(inGame, games[gameName], 55000);
            } else {
                app.util.counter(inGame, 0, 55000);
            }
        } else {
            const containers = document.querySelectorAll('.gametile');
            if (containers) {
                Array.from(containers).forEach((container) => {
                    if (games[container.id]) {
                        container.setAttribute("data-online", games[container.id]);
                        app.util.counter(container.getElementsByClassName("users-online-container")[0], games[container.id], 55000);
                    } else {
                        container.setAttribute("data-online", 0);
                        app.util.counter(container.getElementsByClassName("users-online-container")[0], 0, 55000);
                    }
                });
            }
        }
        return true;
    }

    onConnected() {
        return true;
    }

    onDisconnected() {
        return true;
    }


}
